<template>
  <div>
    <h1 class="text-4xl uppercase text-center pb-1.5 md:pb-3.5 md:pt-6">advertise</h1>
    <hr />
    <div class="h-40 overflow-hidden">
      <swiper
        :modules="[Navigation, Scrollbar, A11y, EffectFade,Autoplay]"
        :slides-per-view="1"
        :navigation="{ clickable: true, prevEl:null,nextEl:null }"
        :preLoadImages="false"
        :lazy="true"
        :loop="true"
        efect="fade"
        :fadeEffect="{ crossFade: true }"
        :autoplay="{delay: 10000}"
      >
        <swiper-slide
          v-for="advertiseTestimonial in advertiseTestimonials"
          :key="advertiseTestimonial.id"
        >
          <div class="pt-11 pb-2.5">
            <p>{{ advertiseTestimonial.text }}</p>
            <span class="text-sm text-themeRed"
              >{{ advertiseTestimonial.who }},</span
            >
            <span class="text-sm text-grayMedium">{{
              advertiseTestimonial.from
            }}</span>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-6 pb-8 md:pb-20 items-center">
      <ul class="divide-y divide-black mb-2 ms:mb-0">
        <li
          class="font-bold text-3xl pb-2.5 pt-5 cursor-pointer"
          v-for="advertiseCategory in advertiseCategories"
          :key="advertiseCategory.order"
          @click="selectCategory(advertiseCategory)"
          :class="current_tab === advertiseCategory.id ? 'bg-black text-white px-2' : ''"
        >
          {{ advertiseCategory.category_name }}
        </li>
      </ul>
      <div class="col-span-6 md:col-span-5 bg-white pl-3.5 pb-3.5 pr-3.5 pl-3.5 shadow-lg">
        <div v-if="imageReady"  v-for="(advertiseCategory,index) in advertiseCategories"
             :key="advertiseCategory.id">
          <nuxt-img
              v-show="advertiseCategory.id=== current_tab"
              width="1800"
              height="1200"
              :preload="index===0"
              format="webp"
              rel="preload"
            class="max-w-full w-full"
            :src="
              siteURL+
                '/storage/images/advertise/' +
                  advertiseCategory.path +
                  '/' +
                  advertiseCategory.thumbnail

            "
            :alt="advertiseCategory.thumbnail"
          />
        </div>
        <div v-else>
          <AdvertiseImageLoader />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Navigation, Scrollbar, A11y, EffectFade,Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import { http } from "~/utils/http";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import {useSiteURL} from "~/composables/state";
import {ref} from "vue";

const siteURL = useSiteURL();

const advertiseTestimonials = ref([]);
const advertiseCategories = ref([]);
const currentAdvertiseCategory = ref([]);
const showColor = ref([]);
const currentAdvertiseCategoryId = ref("0");
let imageReady = ref(true);
let current_tab = ref(0);
const getAdvertiseTestimonials = async () => {
  try {
    await http.get("/api/advertise-testimonials").then((json) => {
      advertiseTestimonials.value = json.data;
      ready.value = true;
    });
  } catch (e) {}
};
getAdvertiseTestimonials();

const selectCategory = (category) =>{
  currentAdvertiseCategory.value=category;
  current_tab.value = currentAdvertiseCategory.value.id;
}

const getAdvertiseCategories = async () => {
  try {
    await http.get("/api/advertise-categories").then((json) => {
      advertiseCategories.value = json.data;
      currentAdvertiseCategory.value = json.data[0];
      current_tab.value = currentAdvertiseCategory.value.id;
      imageReady.value = true;
    });
  } catch (e) {}
};

await getAdvertiseCategories();
</script>
